import { Link } from "react-router-dom";

const NAV_LINKS = [
  { to: "/", label: "Hjem" },
  { to: "/tjenester", label: "Tjenester" },
  { to: "/blogg", label: "Blogg" },
];

const KtrlLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white text-slate-800">
      <header className="border-b border-slate-200">
        <nav className="max-w-5xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
          <Link to="/" className="text-lg font-bold tracking-tight text-slate-900">
            KTRL
          </Link>
          <div className="flex items-center gap-8">
            {NAV_LINKS.slice(1).map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm text-slate-600 hover:text-indigo-600 transition-colors"
              >
                {link.label}
              </Link>
            ))}
            <a
              href="mailto:jakob@ktrl.no"
              className="text-sm font-medium px-4 py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-500 transition-colors"
            >
              Ta kontakt
            </a>
          </div>
        </nav>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-slate-200 bg-slate-50">
        <div className="max-w-5xl mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <p className="font-bold text-slate-900">KTRL AS</p>
            <p className="text-sm text-slate-500 mt-1">
              Holdingselskap og konsulentvirksomhet som bygger, investerer i og drifter AI-drevne tjenester.
            </p>
          </div>
          <div className="text-sm text-slate-500 flex flex-col gap-1 md:items-end">
            <a href="tel:+4790639637" className="hover:text-indigo-600 transition-colors">
              +47 906 39 637
            </a>
            <a href="mailto:jakob@ktrl.no" className="hover:text-indigo-600 transition-colors">
              jakob@ktrl.no
            </a>
            <Link to="/personvern" className="hover:text-indigo-600 transition-colors">
              Personvernerklæring
            </Link>
            <span className="text-slate-400">© {new Date().getFullYear()} KTRL AS</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default KtrlLayout;
